import React from 'react'

function NotFoundPage(props) {
    return (
        <div className='notFound-page'>
            <h1>
                404 Page Not Found
            </h1>
            <div className='imageNFP'>
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUCU7EQa1-hb0UpO3kbUYl3U_Xot1aAuvLDS28B-FM6OfY0ig7wTgWgqgIFQu28L87BxM&usqp=CAU" alt='Pikachu looking for your page' />
            </div>

        </div>
    )
}

export default NotFoundPage